/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
    init: (app, gsap, ScrollTrigger) => {

        /*
        |
        | Constants
        |------------
        */
        const
            $postsContainer = $('.loaded-posts'),

            $loadMoreContainer = $('.load-more-container'),
            $loadMore          = $('.load-more'),
            $loadMoreBtn       = $('.load-more-btn'),
            $loaderContainer   = $('.loader-container')
        ;
 
        /*
        |
        | Ajax vars
        |--------------
        */ 
        let xhr          = null,
            offset       = null,
            url          = null,
            postPerPages = $loadMoreContainer.get(0).dataset.ppp
        ;

        /*
        |
        | Load more ajax
        |--------------
        */
        $loadMoreBtn.on('click', function(e){

            e.preventDefault();
            
            abort(xhr);

            offset = $postsContainer.find('.card-news').length;
            url = `/ajax/posts/${offset}/`;

            Ajax(url);
            
        });


        /*
        |
        | Ajax
        |--------------
        */
        const Ajax = (url, isLoadMore) => {

            abort(xhr);

            xhr = $.ajax({

                url: url,
                type: 'GET',
                method: 'GET',
                dataType: 'json',
                beforeSend: () => {

                    gsap.to(
                        $loadMore,
                        {
                            autoAlpha: 0,
                            y: 20,
                            display: 'none',
                            duration: 0.5,
                            ease: 'Power1.easeOut',
                            onComplete: () => {
                                gsap.fromTo(
                                    $loaderContainer,
                                    {
                                        autoAlpha: 0,
                                        y: 20,
                                        display: 'none'
                                    },
                                    {
                                        autoAlpha: 1,
                                        y: 0,
                                        display: 'block',
                                        duration: 0.5,
                                        ease: 'Power1.easeOut'
                                    }
                                )
                            }
                        }
                    );

                },
                success: (response, status) => {

                    let remainingPosts = null,
                        totalPosts     = null,
                        loadedPosts    = null
                    ;
                    
                    // Append Ajax response
                    $postsContainer.append(response);

                    // Do Math on posts
                    totalPosts = $loadMoreContainer.get(0).dataset.total;
                    loadedPosts = $postsContainer.find('> div').length;
                    remainingPosts = totalPosts - loadedPosts;

                    // Change data-attribute on LoadMore Container
                    $loadMoreContainer.get(0).dataset.count = loadedPosts;

                    // Display or Not LoadMore --> if Posts or Not
                    if ( remainingPosts <= 0 ) {

                        gsap.to($loadMoreContainer, 0.5, { autoAlpha: 0, y: 20, ease: 'Power1.easeOut' });
                        
                    } else {

                        gsap.to(
                            $loaderContainer,
                            {
                                autoAlpha: 0,
                                y: 20,
                                display: 'none',
                                duration: 0.5,
                                ease: 'Power1.easeOut',
                                onComplete: () => {
                                    gsap.fromTo(
                                        $loadMore,
                                        {
                                            autoAlpha: 0,
                                            y: 20,
                                            display: 'none'
                                        },
                                        {
                                            autoAlpha: 1,
                                            y: 0,
                                            display: 'block',
                                            duration: 0.5,
                                            ease: 'Power1.easeOut'
                                        }
                                    )
                                }
                            }
                        );
                        
                        gsap.to($loadMoreContainer, 0.5, { autoAlpha: 1, ease: 'Power1.easeOut'});

                    }

                    ScrollTrigger.refresh();

                    xhr = null;
                },
                error: (response, status, error) => {
                    console.log(error);
                }

            });

        }

        /*
        | HELPER
        |
        | abort ajax request
        |------------
        */
        function abort(xhrVar, $list = null){
            if (xhrVar !== null) {
                xhrVar.abort();
            }

            if($list !== null){
                $list.find('.loading--ajax').hide();
            }
        }

    }
}
